/* eslint-disable linebreak-style */
//import React, { useContext, useState } from "react";
import React from "react";
import {
  TextField,
  Grid,
  FormControlLabel,
  Checkbox,
  //} from "@material-ui/core";
} from "@mui/material";
import { withTheme } from "@emotion/react";
import AmDatePicker from "./AmDatePicker";
import AMAutoComplete from "./AMAutoComplete";
import AMAutoSearch from "./AMAutoSearch";
import * as Enums from "src/utils/enums";
import _ from "lodash";
import { borderColor } from "polished";

function AMFormInput({
  type,
  control,
  name,
  errorMsg,
  options,
  gridItemProps: gridProps,
  theme,
  ...rest
}) {
  // let { type = Enums.ControlType.TextField } = props;
  // const { name, errorMsg, ...rest } = props;
  //const formContext = useContext(FormContext);
  //const { data, errors, frmControls } = formContext;

  // #region
  const ctrl = control || {};
  let { disabled } = rest;

  const label = ctrl.caption ? ctrl.caption : rest.label || name;
  if (!disabled) {
    disabled = ctrl.disabled;
  }

  let dateAdditionalProps = {};
  if (!type && ctrl.dataType) {
    switch (ctrl.dataType.toLowerCase()) {
      case "number":
        type = "number";
        break;
      case "date":
        type = "date";
        dateAdditionalProps = {
          format: "dd/MM/yyyy",
          InputLabelProps: {
            shrink: true,
          },
        };
        break;
      default:
        type = "text";
        break;
    }
  }
  // #endregion
 
  const defaultGridItemProps = {
    lg: 3,
    xl: 3,
    md: 6,
    sm: 6,
    xs: 12,
    style: { paddingBottom: 5, paddingTop: 5 },
  };

  const gridItemProps =
    gridProps && !_.isEmpty(gridProps)
      ? {
          ...defaultGridItemProps,
          ...gridProps,
          style: {
            ...defaultGridItemProps.style,
            ...(gridProps.style || {}),
          },
        }
      : defaultGridItemProps;
  const { lookupId, formId, anotherCriteria, reportId } = ctrl;
  switch (type) {
    case Enums.ControlType.AutoComplete:
      return (
        <Grid
          item
          key={control ? `${control.controlName}_001` : name + "_001"}
          {...gridItemProps}
        >
          <AMAutoComplete
            name={name}
            label={label}
            helperText={errorMsg || ctrl.helperText}
            error={!!errorMsg}
            options={options || []}
            onChange={rest.onChange}
            autoSelectSingleOption={rest.autoSelectSingleOption}
            {...rest}
          />
        </Grid>
      );
    case Enums.ControlType.AutoSearch:
      return (
        <Grid
          item
          key={control ? `${control.controlName}_001` : name + "_001"}
          {...gridItemProps}
        >
          <AMAutoSearch
            name={name}
            //value={val}
            //loadOnce={true}
            //onChange={handleSelectedIndexChange}
            //onChange={onChange}
            // error,
            // helperText,
            // placeholder,
            // variant,
            label={label}
            helperText={errorMsg || ctrl.helperText}
            error={!!errorMsg}
            anotherCriteria={anotherCriteria}
            lookupId={lookupId}
            formId={formId}
            reportId={reportId}
            {...rest}
          />
        </Grid>
      );
    case Enums.ControlType.DatePicker:
      return (
        <Grid
          item
          key={control ? `${control.controlName}_001` : name + "_001"}
          {...gridItemProps}
        >
          <AmDatePicker
            fullWidth={true}
            size="small"
            margin="dense"
            variant="outlined"
            // value={value}
            // onChange={(newValue) => {
            //   setValue(newValue);
            // }}
            renderInput={(params) => <TextField {...params} />}
            //disabled={!!disabled}
            name={name}
            label={label}
            helperText={errorMsg || ctrl.helperText}
            error={errorMsg}
            {...rest}
          />
        </Grid>
      );
    case Enums.ControlType.CheckBox:
      return (
        <Grid
          item
          key={control ? `${control.controlName}_001` : name + "_001"}
          {...gridItemProps}
        >
          <FormControlLabel
            control={
              <Checkbox
                // checked={state.checkedB}
                name={name}
                disabled={!!disabled}
                {...rest}
              />
            }
            label={label}
            //   helperText={errors[name] ? errors[name] : helperText}
          />
        </Grid>
      );
    default:
      // text
      return (
        <Grid
          item
          key={control ? `${control.controlName}_001` : name + "_001"}
          {...gridItemProps}
        >
          <TextField
            //ref={props.ref}
            fullWidth={true}
            size="small"
            margin="dense"
            variant="outlined"
            type={type}
            {...dateAdditionalProps}
            name={name}
            label={label}
            helperText={errorMsg || ctrl.helperText}
            error={!!errorMsg}
             sx={{
    '& .MuiInputBase-input': {
      lineHeight: 1.5,
    },
    // '& .MuiInputBase-inputSizeSmall': {
    //   paddingTop: '10px',
    //   paddingBottom: '10px',
    // },
    '& .MuiInputBase-input.Mui-disabled': {
      fontWeight: 'bold',
      // lineHeight: 1.5,
      WebkitTextFillColor: theme.palette.secondary.main,
      color: theme.palette.secondary.main,
    },
    '& .MuiInputLabel-root': {
      fontWeight: 'bold',
    },
    '& .MuiInputLabel-root.Mui-disabled': {
      fontWeight: 'bold',
      color: theme.palette.secondary.main,
    },
  }}
  {...rest}
          />
        </Grid>
      );
  }
}

export default withTheme(AMFormInput) ;
